// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z\"/> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z\"/> </svg> ";
// Exports
module.exports = code;